// Copyright (c) 2020 Deere & Company

import './index.scss';

import AuthenticatedPage from '../../common/components/authenticated-page';
import BundleAllocationCapacityForecast from '../shared/bundle-allocation-to-capacity-forecast';
import React from 'react';

function BundleAllocationToForecastPage () {

    return (
        <AuthenticatedPage className="atp-page atp-bundle-allocation-to-forecast-page">
            <BundleAllocationCapacityForecast bundleCapacity={false} />
        </AuthenticatedPage>
    );

}
BundleAllocationToForecastPage.displayNAme = 'BundleAllocationToForecastPage';

export default BundleAllocationToForecastPage;
